<div class="header d-none d-md-flex" *ngIf="!hideHeader">
  <div class="container">
    <app-error-banner></app-error-banner>
    <div class="row d-none d-sm-flex">
      <div class="col-6">
        <div class="phone-number text-left mt-1"><img src="assets/images/white_phone.png" class="pe-1" alt="phone_number"> <span class="mt-2 pt-1">{{info?.telephoneNumber | phone}}</span></div>
      </div>
      <div class="col-6">
        <div class="admin-by">
          <span class="mt-2 px-4 float-end" *ngIf="isAdminBy === 'wellfit'">Administered by Wellfit</span>
          <span class="float-end" *ngIf="isAdminBy.includes('careington')">Administered by Careington <br>International Corporation</span>
        </div>
      </div>
    </div>
    <div class="row d-inline d-sm-none d-md-none d-lg-none d-xl-none">
      <div class="col-xs-12">
        <img class="logo" src="assets/images/small-logo.png" alt="Smile Generation Dental Plan"/> <span class="pipe">|</span>
        <span class="phone-number text-left">{{info.telephoneNumber | phone}}</span>
      </div>
    </div>
  </div>
</div>

